import { AgreementReportRepository } from './AgreementReportRepository'
import { JtechStore } from 'src/plugins/mobx'

export default class AgreementReportController {
  static getInstance () {
    return JtechStore.getSingleton('AgreementReportController', new AgreementReportController())
  }

  async loadTableAndFilters () {
    const forms = await AgreementReportRepository.generateAgreementTable()
    const datatable = await AgreementReportRepository.agreementReportSearchDatatable()
    return { forms, datatable }
  }

  async searchAgreement (params) {
    const datatable = await AgreementReportRepository.agreementReportSearch(params)
    return datatable
  }

  async exportCsv (params) {
    return await AgreementReportRepository.exportCsv(params)
  }
}
